import React from "react";
import { CharacterSheet, Atributos } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const AtributosSection: React.FC<Props> = ({ character, onChange }) => {
  const updateAtributo = (key: keyof Atributos, field: "nivel" | "modificador" | "custoTotal", value: number) => {
    const newAtributos = {
      ...character.atributos,
      [key]: {
        ...character.atributos[key],
        [field]: value,
      },
    };
    onChange({ ...character, atributos: newAtributos });
  };

  const atributosList = [
    { key: "FOR" as const, label: "Força (FOR)" },
    { key: "DES" as const, label: "Destreza (DES)" },
    { key: "CON" as const, label: "Constituição (CON)" },
    { key: "INT" as const, label: "Inteligência (INT)" },
    { key: "SAB" as const, label: "Sabedoria (SAB)" },
    { key: "CAR" as const, label: "Carisma (CAR)" },
    { key: "POD" as const, label: "Poder Espiritual (POD)" },
  ];

  return (
    <div className="section">
      <h2>Atributos</h2>
      <table>
        <thead>
          <tr>
            <th>Atributo</th>
            <th>Nível</th>
            <th>Modificador</th>
            <th>Custo Total</th>
          </tr>
        </thead>
        <tbody>
          {atributosList.map((attr) => (
            <tr key={attr.key}>
              <td><strong>{attr.label}</strong></td>
              <td>
                <input
                  type="number"
                  value={character.atributos[attr.key].nivel}
                  onChange={(e) => updateAtributo(attr.key, "nivel", parseInt(e.target.value) || 1)}
                  min="1"
                  max="10"
                />
              </td>
              <td>
                <input
                  type="number"
                  value={character.atributos[attr.key].modificador || ""}
                  onChange={(e) => updateAtributo(attr.key, "modificador", parseInt(e.target.value) || 0)}
                  placeholder="-"
                />
              </td>
              <td>
                <input
                  type="number"
                  value={character.atributos[attr.key].custoTotal || ""}
                  onChange={(e) => updateAtributo(attr.key, "custoTotal", parseInt(e.target.value) || 0)}
                  placeholder="-"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="form-group">
        <label>Total de Pontos Gastos em Atributos</label>
        <input
          type="number"
          value={character.totalPontosGastosAtributos}
          onChange={(e) => onChange({ ...character, totalPontosGastosAtributos: parseInt(e.target.value) || 0 })}
          min="0"
        />
      </div>
    </div>
  );
};
